import { AutogenModelProcessLog, AutogenRowProcessLog } from "./autogen/AutogenModelProcessLog";

export class ModelProcessLog extends AutogenModelProcessLog<RowProcessLog> {
	constructor() {
		super(RowProcessLog);
	}
}

export class RowProcessLog extends AutogenRowProcessLog {
}